"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _extends3 = require("@babel/runtime/helpers/extends");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _icon = require("@pattern-library/icon");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = _extends3({}, null), a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const withLiveValidation = WrappedComponent => {
  const propTypes = {
    /**
     * An array of validation criteria
     */
    criteria: _propTypes.default.arrayOf(_propTypes.default.shape({
      validationMethod: _propTypes.default.func.isRequired,
      errorMessage: _propTypes.default.string.isRequired,
      validationLabel: _propTypes.default.string,
      ariaLabel: _propTypes.default.string
    })).isRequired
  };
  const WithLiveValidation = _ref => {
    let {
      criteria,
      onChange,
      ...props
    } = _ref;
    const [results, setResults] = _react.default.useState([]);
    const validationLabels = criteria.map(_ref2 => {
      let {
        validationLabel
      } = _ref2;
      return validationLabel;
    });
    const ariaLabels = criteria.map(_ref3 => {
      let {
        ariaLabel
      } = _ref3;
      return ariaLabel;
    });
    const handleChange = (0, _react.useCallback)(event => {
      if (onChange) {
        onChange(event);
      }
      const {
        value
      } = event.target;
      setResults(criteria.map(_ref4 => {
        let {
          validationMethod,
          errorMessage
        } = _ref4;
        const isValid = validationMethod(value);
        return {
          isValid,
          errorMessage
        };
      }));
    }, [onChange, criteria]);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "asc-live-validation"
    }, /*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({
      onChange: handleChange,
      "aria-describedby": ariaLabels.join('-')
    }, props)), validationLabels.length > 0 && validationLabels.map((message, index) => {
      const isValid = results.length && results[index].isValid;
      const screenReaderMessage = `${ariaLabels[index]}, is ${isValid ? 'valid' : 'invalid'}.`;
      return message !== undefined && /*#__PURE__*/_react.default.createElement("div", {
        key: message,
        className: `${index !== 0 ? 'asc-mt-1' : ''} asc-live-validation__label`
      }, results.length && isValid ? /*#__PURE__*/_react.default.createElement("div", {
        className: "asc-live-validation__label__icon"
      }, /*#__PURE__*/_react.default.createElement(_icon.CheckBoldIcon, {
        useInlineStyles: true,
        size: 'xxs',
        color: 'success'
      })) : /*#__PURE__*/_react.default.createElement("div", {
        className: "asc-live-validation__label__icon"
      }, /*#__PURE__*/_react.default.createElement(_icon.XBoldIcon, {
        useInlineStyles: true,
        customSize: "11px",
        color: 'gray-60'
      })), /*#__PURE__*/_react.default.createElement("p", {
        className: "asc-form-subtext",
        "aria-hidden": "true"
      }, message), /*#__PURE__*/_react.default.createElement("p", {
        className: "asc-acc-hidden",
        "aria-live": "polite"
      }, screenReaderMessage));
    })));
  };
  WithLiveValidation.propTypes = propTypes;
  return WithLiveValidation;
};
var _default = exports.default = withLiveValidation;